export const CACHE_DB = {
  NAME: 'cache_db',
  VERSION: 2,
  OBJECT_STORES: {
    DETAIL_FORM_MODELS: 'detailFormModels',
    ENTITY_DEFINITIONS: 'entityDefinitions',
  },
  KEY_PATHS: {
    FORM_ENTITY_KEY: 'formEntityKey',
    FORM_KEY: 'formKey',
  },
};

export const OFFLINE_DB = {
  NAME: 'offline_db',
  VERSION: 1,
  OBJECT_STORES: {
    ENTITIES: 'entities',
    REQUESTS: 'requests',
    SEARCH_RESULTS: 'searchResults',
  },
  KEY_PATHS: {
    ID: 'id',
  },
};
